<p-table [value]="posService.checkList.value">
	<ng-template pTemplate="header">
		<tr>
			<th><fa-icon [icon]="['fad', 'clipboard-check']" size="3x"></fa-icon></th>
			<th><fa-icon [icon]="['fad', 'clock']" size="3x"></fa-icon></th>
			<th><fa-icon [icon]="['fad', 'question-circle']" size="3x"></fa-icon></th>
			<th><fa-icon [icon]="['fad', 'sack-dollar']" size="3x"></fa-icon></th>
			<th><fa-icon [icon]="['fad', 'chair']" size="3x"></fa-icon></th>
			<th><fa-icon [icon]="['fad', 'user']"></fa-icon></th>
		</tr>
	</ng-template>
	<ng-template let-rec pTemplate="body">
		<tr (click)="onSelectCheck(rec)">
			<td>
				{{ rec.checkNumber }}
			</td>
			<td>
				{{ posService.app.moment(rec.timeOpened).format("l LT") }}
			</td>
			<td>
				<fa-icon *ngIf="rec.open" [icon]="['fad', 'check-double']"></fa-icon>
				<fa-icon *ngIf="!rec.open" [icon]="['fad', 'times-circle']"></fa-icon>
			</td>
			<td>
				{{ rec.total | currency }}
			</td>
			<td>
				{{ rec.table }}
			</td>
			<td>
				{{ rec.owner }}
			</td>
		</tr>
	</ng-template>
</p-table>
